export var detailsBtn = {
  padding: '0.6em',
  '& > i': {
    margin: 0
  }
};
export var depositsTableWrap = {
  marginBottom: '2.5em',
  '& > div': {
    margin: 0
  }
};
export var typeColor = function typeColor(color) {
  return function (theme) {
    return {
      color: theme[color]
    };
  };
};